import * as React from 'react';

import { INotification } from  '@models';
import { IWorkerType  } from '@models/resources';
import {
    classNames,
    InputText,
    NotificationsBox,
    useForm,
    useTranslation,
    ValidationBuilder,
} from '@components';

import './WorkForm.css';

export interface IProps {
    data?: IWorkerType;
    workId: number;
    footer?: any;
    notifications: INotification[];
    onChange?: Function;
    onSubmit: Function;
}

export const validateWorkerType = (data: IWorkerType) => {
    return ValidationBuilder.create(data).notEmpty('name').build();
}

export const isValid = (data: IWorkerType) => {
    return Object.keys(validateWorkerType(data)).length == 0;
}

export function WorkerTypeForm(props: IProps) {
    const { t } = useTranslation();

    const form = useForm<IWorkerType>({
        initialValues: {
            id: props.data?.id ?? 0,
            name: props.data?.name ?? '',
            workId: props.workId,
        },
        validate: validateWorkerType,
        onSubmit: (data: IWorkerType) => {
            props.onSubmit(data);
            return {ok: true};
        },
        onChange: props.onChange,
    });

    return <div>
        <form onSubmit={form.handleSubmit}
            className='p-fluid'>
            <div className='c md pd g-30'>
                {form.floatField('name', t('Name'), () =>
                    <InputText
                    id='name'
                    type='text'
                    value={form.values.name}
                    onChange={form.handleChange}
                    autoFocus
                    className={classNames({ 'p-invalid': !form.isFormFieldValid('name')})}/>
                )}
            </div>
            <div className='errors-container'>
                {form.errorBox()}
                <NotificationsBox notifications={props.notifications}/>
            </div>
            {props.footer != undefined && props.footer}
        </form>
    </div>
}